import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Typography } from 'antd';
import { Trans } from 'react-i18next';
import { WhatsApp } from '@whatsper/texterchat-common';
import { CALL_TO_ACTION_TYPES } from '../../../../../../../constants';
import { useStore } from '../../../../../../../store/rootStore';
import HeaderSection from './sections/HeaderSection';
import FooterSection from './sections/FooterSection';
import ButtonsSection from './sections/ButtonsSection';
import PreviewWrapperSection from './sections/PreviewWrapperSection';
import s from './RichParams.module.scss';
const { Text } = Typography;
const RichParams = () => {
    const [callToActionButtonLimit] = useState(2);
    const [quickReplyButtonLimit] = useState(3);
    const [sampleDataModalIsOpen, setSampleDataModalIsOpen] = useState(false);
    const [fillButton, setFillButton] = useState(false);
    const { templateMessagesStore } = useStore();
    const { templateMessage, handleSetFooter, hasAllSampleParamsAdded, hasAtLeastOneSampleParamAdded, hasSampleParamsSetup, currentTemplate, setTempExampleParam, bodyExampleParams, callToActionButtonUrlExamples, } = templateMessagesStore;
    const actionButtonsValidation = (button, buttonIndex) => {
        var _a;
        if (button.type === CALL_TO_ACTION_TYPES.URL && button.url.length > 0 && !button.url.includes('https://')) {
            return (React.createElement(Text, { className: s.buttonsError },
                React.createElement(Trans, { i18nKey: "urlMustInclude" })));
        }
        else if (button.type === CALL_TO_ACTION_TYPES.PHONE_NUMBER &&
            button.phone_number &&
            button.phone_number.length > 0 &&
            !button.phone_number.startsWith('+')) {
            return (React.createElement(Text, { className: s.buttonsError },
                React.createElement(Trans, { i18nKey: "phoneMustStartWith" })));
        }
        else if (((_a = button.text) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            return (React.createElement(Text, { className: s.buttonsError },
                React.createElement(Trans, { i18nKey: "textFieldIsRequired" })));
        }
        else if (button.type === CALL_TO_ACTION_TYPES.URL &&
            button.url &&
            /{{.*?}}/.test(button.url) &&
            (!callToActionButtonUrlExamples[buttonIndex] || callToActionButtonUrlExamples[buttonIndex].trim() === '')) {
            return (React.createElement(Text, { className: s.buttonsError },
                React.createElement(Trans, { i18nKey: "urlExampleRequired" })));
        }
        else if (button.type === CALL_TO_ACTION_TYPES.URL &&
            button.url &&
            /{{.*?}}/.test(button.url) &&
            !button.url.match(/{{.*?}}$/g)) {
            return (React.createElement(Text, { className: s.buttonsError },
                React.createElement(Trans, { i18nKey: "placeholderMustBeAtEndOfUrl" })));
        }
        return null;
    };
    const blockField = () => {
        return !!(currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.status) && currentTemplate.status !== 'NEW';
    };
    const blockMessagePreviewField = () => {
        if (templateIsApproved())
            return false;
        return blockField();
    };
    const templateIsApproved = () => {
        return (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.status) === WhatsApp.TemplateLocalizationStatus.APPROVED;
    };
    const switchOpenSampleDataModal = () => {
        if (!sampleDataModalIsOpen) {
            setTempExampleParam(bodyExampleParams);
        }
        else {
            setTempExampleParam(null);
        }
        setSampleDataModalIsOpen(!sampleDataModalIsOpen);
    };
    return (React.createElement("div", { className: s.richBlock },
        React.createElement("div", { className: s.inputsBlock },
            React.createElement(HeaderSection, { blockField: blockField }),
            React.createElement(FooterSection, { handleSetFooter: handleSetFooter, blockField: blockField }),
            React.createElement(ButtonsSection, { actionButtonsValidation: actionButtonsValidation, callToActionButtonLimit: callToActionButtonLimit, quickReplyButtonLimit: quickReplyButtonLimit, blockField: blockField })),
        React.createElement(PreviewWrapperSection, { templateMessage: templateMessage, hasAllSampleParamsAdded: hasAllSampleParamsAdded, hasAtLeastOneSampleParamAdded: hasAtLeastOneSampleParamAdded, hasSampleParamsSetup: hasSampleParamsSetup, sampleDataModalIsOpen: sampleDataModalIsOpen, fillButton: fillButton, blockMessagePreviewField: blockMessagePreviewField, templateIsApproved: templateIsApproved, switchOpenSampleDataModal: switchOpenSampleDataModal, onMouseEnter: () => setFillButton(true), onMouseLeave: () => setFillButton(false), blockField: blockField })));
};
export default observer(RichParams);
